// "Satın al" penceresi: paket sınırı / ücretli özellik / abonelik kilidi.
// PlanProvider açar (402 izleyicisi ya da openPaywall). "Paketleri gör" → /subscription.
import { useNavigate } from 'react-router';
import { Crown, Lock } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { useI18n } from '../contexts/LanguageContext';
import { planLimitText, planUiText } from '../lib/plan-texts';

interface PlanLimitDialogProps {
  open: boolean;
  feature: string;
  limit?: number;
  onClose(): void;
}

export function PlanLimitDialog({ open, feature, limit, onClose }: PlanLimitDialogProps) {
  const navigate = useNavigate();
  const { language } = useI18n();
  const ui = planUiText(language);
  const text = planLimitText(feature, language, limit);
  const isLock = feature === 'SUBSCRIPTION_READ_ONLY' || feature === 'ACCOUNT_CLOSED';
  const Icon = isLock ? Lock : Crown;

  const goToPlans = () => {
    onClose();
    navigate('/subscription');
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="sm:max-w-md" aria-describedby="plan-limit-desc">
        <DialogHeader>
          <div className={`mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-full ${isLock ? 'bg-orange-100 text-orange-600' : 'bg-blue-100 text-blue-600'}`}>
            <Icon className="h-6 w-6" />
          </div>
          <DialogTitle className="text-center">{text.title}</DialogTitle>
          <DialogDescription id="plan-limit-desc" className="text-center">
            {text.body}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:justify-center">
          <Button variant="outline" onClick={onClose}>{ui.close}</Button>
          <Button className="bg-blue-600 hover:bg-blue-700 text-white" onClick={goToPlans}>
            {isLock ? ui.renew : ui.seePlans}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
